export function substituteURLParametersInPath(path, urlParameters) {

  let _path = path;
  const _urlParameters = {
    ...urlParameters
  };

  for (let key in _urlParameters) {

    _path = _path.replace(new RegExp(':' + key), _urlParameters[key]);

  }

  return _path;

}